(() => {
  const scheduleExisting = window.__oriaviStickyCartEnhancementsSchedule;
  if (typeof scheduleExisting === 'function') {
    scheduleExisting();
    return;
  }

  let frame = 0;

  const getMainSizePicker = () => document.querySelector('[data-oriavi-size-picker]');

  const isSizeSelect = (select) => {
    const name = String(select.name || '').toLowerCase();
    const slug = String(select.closest('.variant-input-wrapper')?.dataset.optionSlug || '').toLowerCase();
    return name.includes('size') || slug.includes('size');
  };

  const visibleMainSizeText = (picker, value) => {
    const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
    const input = radios.find((radio) => radio.value === value);
    if (!input) return '';

    const label = input.labels && input.labels.length ? input.labels[0] : null;
    const display = label?.querySelector('[data-oriavi-size-display]');
    return String(display?.textContent || '').trim();
  };

  const currentUnit = () => {
    const active = document.querySelector('[data-oriavi-size-units] [data-oriavi-unit][aria-pressed="true"]');
    if (active?.dataset.oriaviUnit) return active.dataset.oriaviUnit;

    try {
      const stored = localStorage.getItem('oriavi-size-unit');
      if (stored === 'in' || stored === 'cm') return stored;
    } catch (error) {
      // The main size controller still works when storage is unavailable.
    }
    return '';
  };

  const syncStickySizeText = () => {
    const picker = getMainSizePicker();
    if (!picker) return;

    const unit = currentUnit();
    const stickySelects = Array.from(
      document.querySelectorAll('.oriavi-sticky-variant-selects[data-sticky] select')
    ).filter(isSizeSelect);

    stickySelects.forEach((select) => {
      Array.from(select.options).forEach((option) => {
        if (!option.value || option.dataset.oriaviPlaceholder === 'true') return;

        const text = visibleMainSizeText(picker, option.value);
        if (text && option.textContent.trim() !== text) {
          option.textContent = text;
        }
      });

      if (unit) select.dataset.oriaviDisplayUnit = unit;
    });
  };

  const scheduleSync = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => {
        frame = 0;
        syncStickySizeText();
      });
    });
  };

  window.__oriaviStickyCartEnhancementsSchedule = scheduleSync;
  window.__oriaviStickyCartEnhancementsSync = syncStickySizeText;

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-oriavi-unit]')) scheduleSync();
  });

  document.addEventListener('change', (event) => {
    if (
      event.target.closest?.('[data-oriavi-size-picker]') ||
      event.target.closest?.('.oriavi-sticky-variant-selects[data-sticky]')
    ) {
      scheduleSync();
    }
  });

  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => {
      const target = mutation.target?.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target?.parentElement;

      if (
        target?.closest?.('[data-oriavi-size-picker]') ||
        target?.closest?.('.oriavi-sticky-variant-selects[data-sticky]')
      ) {
        return true;
      }

      return Array.from(mutation.addedNodes || []).some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        return Boolean(
          node.matches?.('[data-oriavi-size-picker], .oriavi-sticky-variant-selects[data-sticky]') ||
          node.querySelector?.('[data-oriavi-size-picker], .oriavi-sticky-variant-selects[data-sticky]')
        );
      });
    });

    if (relevant) scheduleSync();
  });

  const start = () => {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
    scheduleSync();
    window.setTimeout(syncStickySizeText, 120);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleSync);
})();
